import { Collapse, Divider, Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
} from "../../components/styled/common";
import { DocCategoryItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useDocumentContext } from "../../context/DocumentContext/DocumentContext";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const EditDocument = () => {
	const { id } = useParams<{ id: string }>();
	const { state } = useLocation();
	const categoryId = state?.categoryId;
	const { updateDocument, getDocumentDetail, getDocumentCategoryDetail, clearDocumentData, operationStatus } = useDocumentContext();

	useEffect(() => {
		clearDocumentData();

		if (id) {
			getDocumentDetail(id);
			getDocumentCategoryDetail(categoryId);
		}

		return () => {
			clearDocumentData();
		};
	}, [id, categoryId]);

	return (
		<ActionContainer>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<ActionItemsContainer>
					<h3>Doküman Güncelleme</h3>
					<Divider />
					<Collapse
						items={DocCategoryItems}
						expandIconPosition="end"
						bordered={false}
						ghost
						expandIcon={CollapseExpandIcon}
						defaultActiveKey={["1", "2", "3"]}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent onClick={updateDocument} loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
							Güncelle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</Spin>
		</ActionContainer>
	);
};

export default EditDocument;
